// extracted by mini-css-extract-plugin
export default {"container":"zo-z","ratingLayout":"Ao-z","ratingLabel":"Bo-z","nonInteractiveRatingLabel":"Co-z"};